import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { IUser } from "../interfaces/User";

@Injectable()
export class UserService {
  url = '';

  constructor(private _http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + 'api/users';
  }

  private handleError(operation: String) {
    return (err: any) => {
      let errMsg = `error in ${operation}() retrieving ${this.url}`;
      console.log(`${errMsg}:`, err)
      if (err instanceof HttpErrorResponse) {
        // you could extract more info about the error if you want, e.g.:
        console.log(`status: ${err.status}, ${err.statusText}`);
        // errMsg = ...
      }
      return Observable.throw(err);
    }
  }
  // public API
  public getUsers(): Observable<IUser[]> {
    // HttpClient.get() returns the body of the response as an untyped JSON object.
    // We specify the type as SomeClassOrInterfaceto get a typed result.
    return this._http.get<IUser[]>(this.url)
      .pipe(
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('getUsers'))
      );
  }

  public getUser(userName: string): Observable <IUser>{
    return this._http.get<IUser>(this.url + '/' + userName)
      .pipe(
      tap(data => console.log('server data:', data)),
        catchError(this.handleError('getUsers'))
      );
  }

  public putUser(user: IUser): Observable<IUser> {
    return this._http.put<IUser>(this.url, user)
      .pipe(
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('putUser'))
      );
  }

  public updateUser(user: IUser): Observable<IUser> {
    return this._http.put<IUser>(this.url + '/' + user.userName, user)
      .pipe(
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('putUser'))
      );
  }

      public deleteUser(user: IUser): Observable<IUser> {
    //let  headers  = new HttpHeaders({
    //  'Content-Type': 'application/json'
    //});

    //const params = Object.getOwnPropertyNames(user)
    //  .reduce((p, key) => p.set(key, user[key]), new HttpParams());

    return this._http.delete(this.url + '/' + user.userName)
      .pipe(
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('deleteUser'))
      );
  }
}
